// extracted by mini-css-extract-plugin
export default {"modalContent":"CancelAdditionalChargeModal_modalContent__htVNc"};